import { defaultTo, includes, isEmpty, map, path, reject, uniq } from 'ramda';
import { sanitizeCmsText } from './cmsText.js';

// Clés déclarées dans le CMS, groupe ENTREPRISE_ZONE_COUVERTURE
export const COVERAGE_ZONE_FLAGS = Object.freeze({
  IS_NECESSARY: 'ENTREPRISE_ZONE_COUVERTURE_EST_NECESSAIRE',
  IS_REQUIRED: 'ENTREPRISE_ZONE_COUVERTURE_EST_OBLIGATOIRE',
  LABEL: 'ENTREPRISE_ZONE_COUVERTURE_LABEL',
  BUTTON_LABEL: 'ENTREPRISE_ZONE_COUVERTURE_LABEL_BOUTON'
});

export const DEFAULT_COVERAGE_ZONE_LABEL = 'Zone de couverture';
export const DEFAULT_ADD_ZONE_BUTTON_LABEL = 'Ajouter une zone de couverture';

export const getCoverageZoneFlags = (getMiddleBoolean, getMiddleText) => ({
  isDisplayed: Boolean(getMiddleBoolean(COVERAGE_ZONE_FLAGS.IS_NECESSARY)),
  isRequired: Boolean(getMiddleBoolean(COVERAGE_ZONE_FLAGS.IS_REQUIRED)),
  label: sanitizeCmsText(
    getMiddleText(COVERAGE_ZONE_FLAGS.LABEL),
    COVERAGE_ZONE_FLAGS.LABEL,
    DEFAULT_COVERAGE_ZONE_LABEL
  ),
  addButtonLabel: sanitizeCmsText(
    getMiddleText(COVERAGE_ZONE_FLAGS.BUTTON_LABEL),
    COVERAGE_ZONE_FLAGS.BUTTON_LABEL,
    DEFAULT_ADD_ZONE_BUTTON_LABEL
  )
});

// Les zones sélectionnées, alignées sur l'index des blocs : buildZoneOptions s'appuie sur cet alignement
export const getSelectedZones = (demographies) =>
  map(path(['salesArea', 'label']), defaultTo([], demographies));

const filledZones = (selectedZones) =>
  uniq(reject((zone) => !zone, defaultTo([], selectedZones)));

// Une zone prise par un autre bloc est retirée de la liste : le SearchableSelect du design
// system ignore option.disabled, la griser la laisserait cliquable. Celle du bloc courant est
// conservée, sinon le select ne pourrait pas afficher sa propre valeur.
export const buildZoneOptions = (coverageZones, selectedZones, index) =>
  reject(
    ({ value }) =>
      includes(value, filledZones(selectedZones)) &&
      selectedZones?.[index] !== value,
    defaultTo([], coverageZones)
  );

export const isAddZoneDisabled = (coverageZones, selectedZones) => {
  const zones = defaultTo([], coverageZones);

  return isEmpty(zones) || filledZones(selectedZones).length >= zones.length;
};

// Le premier bloc n'est pas supprimable : il porte la démographie du parcours mono-zone
export const canRemoveZone = (index) => index > 0;

export const emptyDemographyBlock = () => ({
  employeeCount: '',
  employeeAverageAge: '',
  partnerCount: '',
  childrenCount: '',
  salesArea: { label: '' },
  socialSecurities: [{ regime: undefined }],
  payrolls: {}
});
